import {detail, list, utils, shared, authActions} from "@mc/mc-legacy";
import * as ciselnikActions from "../actions/ciselnikActions";
import * as polozkaActions from "../actions/polozkaActions";
import * as subjektActions from "../actions/subjektActions";
import * as opravneniActions from "../actions/opravneniActions";
import * as objednavkaActions from "../actions/objednavkaActions";
import * as uzivatelActions from "../actions/uzivatelActions";
import * as notifikaceActions from "../actions/notifikaceActions";
import {CENIKY_SPOLECNOST_LIST_AREA} from "../actions/polozkaActions";

/**
 * Hlavní store aplikace.
 */
const initialState = {
    [authActions.AUTH_INFO_AREA]: detail.DetailReducer(),

    [ciselnikActions.FIRMA_AREA]: detail.DetailReducer(),
    [ciselnikActions.SAZBY_DPH_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.NAKLADOVA_STREDISKA_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.DOPRAVCI_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.TERMIN_DOPRAVY_AREA]: detail.DetailReducer(),
    [ciselnikActions.TERMINY_DOPRAVY_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.TERMINY_DOPRAVY_OPERATOR_LIST_AREA]: list.SimpleListReducer(), // termíny dopravy pro formulář editace objednávky, protože jiný panel může ve stejnou chvíli potřebovat mít načtený seznam pro jiný způsob dopravy
    [ciselnikActions.ZPUSOBY_DOPRAVY_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.ZPUSOBY_PLATBY_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.UKONY_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.SOUBOR_ATRIBUTY_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.POBOCKY_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.POBOCKY_NEVYDEJNI_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.POBOCKA_AREA]: detail.DetailReducer(),
    [ciselnikActions.ZPUSOB_PLATBY_AREA]: detail.DetailReducer(),
    [ciselnikActions.ZPUSOB_DOPRAVY_AREA]: detail.DetailReducer(),
    [ciselnikActions.POBOCKY_UZIVATEL_LIST_AREA]: list.SimpleListReducer(),
    [ciselnikActions.POBOCKY_OPERATOR_LIST_AREA]: list.SimpleListReducer(),

    [polozkaActions.FAKTURACNI_POLOZKY_LIST_AREA]: list.SimpleListReducer(),
    [polozkaActions.CENIKY_SPOLECNOST_LIST_AREA]: list.SimpleListReducer(),
    [polozkaActions.CENIKY_LIST_AREA]: list.SimpleListReducer(),
    [polozkaActions.CENIK_POLOZKY_LIST_AREA]: list.SimpleListReducer(),
    [polozkaActions.PAROVANI_POLOZKY_LIST_AREA]: list.SimpleListReducer(),

    [subjektActions.SPOLECNOSTI_LIST_AREA]: list.SimpleListReducer(),
    [subjektActions.SPOLECNOST_ZAMESTNANCI_LIST_AREA]: list.SimpleListReducer(),
    [subjektActions.SPOLECNOST_ADRESY_LIST_AREA]: list.SimpleListReducer(), // všechny adresy společnosti
    [subjektActions.SPOLECNOST_AKTIVNI_ADRESY_LIST_AREA]: list.SimpleListReducer(), // pouze aktivní adresy společnosti
    [subjektActions.SPOLECNOST_KARTY_LIST_AREA]: list.SimpleListReducer(),
    [subjektActions.SPOLECNOST_DETAIL_AREA]: detail.DetailReducer(),
    [subjektActions.SPOLECNOST_ADRESA_AREA]: detail.DetailReducer(),
    [subjektActions.SPOLECNOST_RIGHTS_AREA]: detail.DetailReducer(), // oprávnění na společnost
    [subjektActions.SPOLECNOST_POBOCKY_VYDEJ_LIST_AREA]: list.SimpleListReducer(),
    [subjektActions.SPOLECNOST_POBOCKY_VYDEJ_VCETNE_VYDEJNI_LIST_AREA]: list.SimpleListReducer(),

    [subjektActions.UZIVATELE_LIST_AREA]: list.SimpleListReducer(),
    [subjektActions.UZIVATEL_ADRESY_LIST_AREA]: list.SimpleListReducer(), // všechny adresy uživatele
    [subjektActions.UZIVATEL_AKTIVNI_ADRESY_LIST_AREA]: list.SimpleListReducer(), // pouze aktivní adresy uživatele
    [subjektActions.UZIVATEL_SPOLECNOSTI_LIST_AREA]: list.SimpleListReducer(), // společnosti přiřazené uživateli
    [subjektActions.UZIVATEL_KARTY_LIST_AREA]: list.SimpleListReducer(),
    [subjektActions.UZIVATEL_DETAIL_AREA]: detail.DetailReducer(),
    [subjektActions.UZIVATEL_AKTIVNI_SPOLECNOST_AREA]: detail.DetailReducer(), // aktivně zvolená společnost uživatele
    [subjektActions.UZIVATEL_ADRESA_AREA]: detail.DetailReducer(),
    [subjektActions.UZIVATEL_RIGHTS_AREA]: detail.DetailReducer(), // oprávnění na uživatele
    [subjektActions.UZIVATEL_VYCHOZI_HODNOTY_AREA]: detail.DetailReducer(), // výchozí hodnoty uživatele

    [opravneniActions.LOGGED_IN_USER_AREA]: detail.DetailReducer(), // data a oprávnění právě přihlášeného uživatele

    [objednavkaActions.OBJEDNAVKA_DETAIL_AREA]: detail.DetailReducer(), // detail konkrétní objednávky
    [objednavkaActions.OBJEDNAVKA_RIGHTS_AREA]: detail.DetailReducer(), // oprávnění na objednávku

    // Data vztahující se k uživateli za kterého je prováděna objednávka operátorem
    [objednavkaActions.OBJEDNAVKA_UZIVATEL_AREA]: detail.DetailReducer(),
    [objednavkaActions.OBJEDNAVKA_UZIVATEL_ADRESY_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_UZIVATEL_KARTY_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_UZIVATEL_POBOCKY_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_UZIVATEL_VYCHOZI_HODNOTY_AREA] : detail.DetailReducer(),

    // Data společnosti uživatele za kterého je prováděna objednávka operátorem
    [objednavkaActions.OBJEDNAVKA_SPOLECNOST_AREA]: detail.DetailReducer(),
    [objednavkaActions.OBJEDNAVKA_SPOLECNOST_ADRESY_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_SPOLECNOST_KARTY_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_SPOLECNOST_NAKLSTRED_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_SPOLECNOST_PREDVOLBY_AREA] : detail.DetailReducer(),
    [objednavkaActions.OBJEDNAVKA_SEZNAM_SMJ_AREA] : list.SimpleListReducer(),
    [objednavkaActions.OBJEDNAVKA_KOD_UKON_LIST_AREA] : list.SimpleListReducer(), // seznam kódů ukonů které jsou na objednávce nastaveny

    [objednavkaActions.OBJEDNAVKY_SHARED_AREA]: shared.AreaGroupReducer({
        objednavkyList: list.InfiniteListReducer(undefined, {}, {filter: {stav: objednavkaActions.FILTR_ZPRACOVAVANE}, loadMoreCount: 30}),
        objednavkyPrehledList: list.SimpleListReducer(), // několik "důležitých" objednávek pro zobrazení na hlavní stránce
        objednavkyListCountStats: detail.DetailReducer(), // statistiky počtu objednávek dle stavů
    }),

    // Dočasně uložená data rozpracované objednávky
    [objednavkaActions.OBJEDNAVKA_SHARED_AREA]: shared.AreaGroupReducer({
        zakazka: detail.DetailReducer(),
        zakaznik: detail.DetailReducer(),
        doprava: detail.DetailReducer(),
        platba: detail.DetailReducer(),
    }),
    [objednavkaActions.LAST_SAVED_STEP_AREA]: detail.DetailReducer(), // číslo posledního kroku rozpracované objednávky pro který jsou uložena data
    [objednavkaActions.LAST_SAVED_FINISHED_STEP_AREA]: detail.DetailReducer(), // číslo posledního kroku rozpracované objednávky který byl dosud dokončen
    [objednavkaActions.CAS_ROZPRACOVANI_DETAIL_AREA]: detail.DetailReducer(), // čas rozpracování objednávky (=prvního uložení dat prvního kroku)

    // Data vztahující se k přihlášenému uživateli
    [uzivatelActions.SHARED_AREA]: shared.AreaGroupReducer({
        spolecnostId: detail.DetailReducer(), // ID právě aktivní společnosti přihlášeného uživatele
        spolecnostiList: list.SimpleListReducer(), // seznam společností přihlášeného uživatele
    }),
    [uzivatelActions.AD_IMPORT_AREA]: detail.DetailReducer(), // nastavení importu z AD

    [notifikaceActions.NOTIFIKACE_LIST_AREA]: list.SimpleListReducer(), // seznam všech notifikací
    [notifikaceActions.NOTIFIKACE_HELP_LIST_AREA]: list.SimpleListReducer(), // seznam existujících zástupných znaků pro tvorbu notifikací
};

export default function app(state = initialState, action) {

    if (action.area) {
        // Pokud se jedná o areu auth a akce je a o akci login, otestujeme, zda se přihlásil stejný uživatel nebo jiný, v případě jiného mažeme aplikační store
        if (action.area === authActions.AUTH_INFO_AREA && action.type === authActions.AUTH_LOGIN) {
            const prev = action.prevAuthInfo;
            const next = action.nextAuthInfo;
            if (prev.fetched && prev.data.login !== next.data.login) {  // jiný uživatel
                return app(undefined, {});
            }
        }

        return utils.processAreaStores(state, action);
    }
    return state;
}
